export const ServiceTypeConstants = {
    GET_SERVICE_TYPE_REQUEST: 'GET_SERVICE_TYPE_REQUEST',
    GET_SERVICE_TYPE_SUCCESS: 'GET_SERVICE_TYPE_SUCCESS',
    GET_SERVICE_TYPE_FAILURE: 'GET_SERVICE_TYPE_FAILURE',
    
}


// WEBPACK FOOTER //
// ./src/store/constants/serviceType.constants.js